var map = {
	"./CloseUp.svg": "52e8",
	"./DoctorsFolder.svg": "dd74",
	"./Group4.svg": "d481",
	"./Insomnia.svg": "6ae6",
	"./Nurse.svg": "0316",
	"./OxygenMask.svg": "cce7",
	"./ScubaTank.svg": "8a4c",
	"./bi_house-door-fill.svg": "8502",
	"./carbon_airline-passenger-care.svg": "db31",
	"./close.svg": "1d1b",
	"./image 2.svg": "9e6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";